import 'croppie/croppie.css';

import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

const PhotoCropper = dynamic(() => import('../components/photoCropper'), {
  ssr: false,
});

const PhotoCropperContext = createContext();

export const PhotoCropperContextProvider = props => {
  const [isVisible, setIsVisible] = useState(props.isVisible);

  const [params, setParams] = useState({});

  const show = (p = {}) => {
    setIsVisible(true);
    setParams(p);
  };

  const hide = () => {
    setIsVisible(false);
    setParams({});
  };

  const handleOnSuccess = photoData => {
    params.onSuccess(photoData);
    hide();
  };

  return (
    <PhotoCropperContext.Provider
      value={{
        show,
        hide,
      }}
    >
      {props.children}

      {isVisible && (
        <PhotoCropper
          placeholder={params.placeholder}
          photo={params.photo}
          onClose={hide}
          onSuccess={handleOnSuccess}
        />
      )}
    </PhotoCropperContext.Provider>
  );
};

PhotoCropperContextProvider.propTypes = {
  isVisible: PropTypes.bool,
  children: PropTypes.node,
};

PhotoCropperContextProvider.defaultProps = {
  isVisible: false,
};

const usePhotoCropperContext = () => {
  return useContext(PhotoCropperContext);
};

export default usePhotoCropperContext;
